import { render, staticRenderFns } from "./NewAdminEditor.vue?vue&type=template&id=efacc262&"
import script from "./NewAdminEditor.vue?vue&type=script&lang=js&"
export * from "./NewAdminEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports